import { z } from "zod";
import { createEndpoint } from "../createEndpoint";
import type { HttpClient, QueryParams } from "../httpClient";
import { PublicPartnerBadgeByIdSchema, PublicPartnerBadgeGroupSchema, PublicPartnerBadgeSchema } from "../schemas/badge";

export interface BadgesByIdsQueryParams extends QueryParams {
    ids: number[];
}

export interface PublicBadgeSearchQueryParams extends QueryParams {
    search?: string;
    tag?: string;
    limit?: number;
}

export interface BadgesBySlugsQueryParams extends QueryParams {
    slugs: string[];
}

export interface GroupedBadgesQueryParams extends QueryParams {
    tags?: string[];
}

export function createPublicBadgesApi(http: HttpClient, baseUrl: string) {
    const publicBadgesBaseUrl = `${baseUrl}/partner-badges`;

    return {
        getBadgesByIds: createEndpoint<
            z.infer<typeof PublicPartnerBadgeByIdSchema>[],
            unknown,
            BadgesByIdsQueryParams
        >(http, "GET", "/by-ids", {
            base: publicBadgesBaseUrl,
            responseSchema: z.array(PublicPartnerBadgeByIdSchema),
        }),

        searchBadges: createEndpoint<
            z.infer<typeof PublicPartnerBadgeByIdSchema>[],
            unknown,
            PublicBadgeSearchQueryParams
        >(http, "GET", "/search", {
            base: publicBadgesBaseUrl,
            responseSchema: z.array(PublicPartnerBadgeByIdSchema),
        }),

        getBadgesBySlugs: createEndpoint<
            z.infer<typeof PublicPartnerBadgeSchema>[],
            unknown,
            BadgesBySlugsQueryParams
        >(http, "GET", "/by-slugs", {
            base: publicBadgesBaseUrl,
            responseSchema: z.array(PublicPartnerBadgeSchema),
        }),

        getGroupedBadges: createEndpoint<
            z.infer<typeof PublicPartnerBadgeGroupSchema>[],
            unknown,
            GroupedBadgesQueryParams
        >(http, "GET", "/grouped", {
            base: publicBadgesBaseUrl,
            responseSchema: z.array(PublicPartnerBadgeGroupSchema),
        }),
    };
}
